"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NumberFormatter_1 = __importDefault(require("@react/web/Common/NumberFormatter/NumberFormatter"));
class MileageYearly {
    constructor(active, value, monthlyMileage, services, priceOfferId) {
        this.active = active;
        this.value = value;
        this.monthlyMileage = monthlyMileage;
        this.services = services;
        this.priceOfferId = priceOfferId;
    }
    getLabel() {
        return `${NumberFormatter_1.default.formatMileage(this.value)}
            <span class="sub-item">(${NumberFormatter_1.default.formatMileage(this.monthlyMileage)}/měsíčně)</span>`;
    }
    getKey() {
        return `mileage-${this.value}`;
    }
}
exports.default = MileageYearly;
